import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { Wrapper, Card, Image, Lesson, Subtitle } from "./CardsStyle"
import { cardImages } from "./CardsImages"
import { updateLessonsRange, updateCurrentLesson } from "../../../features/lessons/lessonSlice"
import { myprogress } from "../../../i18n/04_myprogress"


const Cards = ({guestClick}) => {

  const dispatch = useDispatch()

  const token = useSelector((state) => state.auth?.token) 

  const lang = useSelector(state => state.lang.lang)

  const t = myprogress[lang]

  const assignLesson = (e) => {
    const clickedLesson = Number(e.currentTarget.id) // 1, 7, 13, 19, 25
    const lessonToOpen = token ? clickedLesson : 1 // ✅ guests always go to lesson 1

    dispatch(updateLessonsRange(lessonToOpen))
    dispatch(updateCurrentLesson(lessonToOpen))
    guestClick()
  }

  const cardsData = (t.titles || []).map((it, index) => ({
    title: it.title,
    subtitle: it.subtitle,
    image: cardImages[index],
  }));

  return (
    <Wrapper>
      {cardsData.map((value, index) => (
        <Card
          id={(index + 1) * 6 - 5}
          onClick={assignLesson}
          key={index}
          to="/myprogress/lesson"
        >
          <Image src={value.image} index={index} />
          <Lesson>{value.title}<Subtitle>{value.subtitle}</Subtitle></Lesson>
        </Card>
      ))}
    </Wrapper>
  )
}

export default Cards